module.exports = __webpack_public_path__ + "img/v4_underlyingPlatMarketList_h.fcc1ce43.png";